import { render, staticRenderFns } from "./text-row-date.vue?vue&type=template&id=13d52840&scoped=true&"
import script from "./text-row-date.vue?vue&type=script&lang=js&"
export * from "./text-row-date.vue?vue&type=script&lang=js&"
import style0 from "./text-row-date.vue?vue&type=style&index=0&id=13d52840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d52840",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13d52840')) {
      api.createRecord('13d52840', component.options)
    } else {
      api.reload('13d52840', component.options)
    }
    module.hot.accept("./text-row-date.vue?vue&type=template&id=13d52840&scoped=true&", function () {
      api.rerender('13d52840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/text-row-date.vue"
export default component.exports